import React, { useEffect, useState } from 'react';

import { useAppSelector } from '../../../../../store';
import { FinanceFilters } from '../service/finance.interface';
import { initialTableFilters } from '../utils/filters';
import { FinanceTable } from '../components/FinanceTable';
import { useLazyGetFinancePaymentHistoryQuery } from '../service/finance.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const FinanceContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [tableFilters, setTableFilters] =
        useState<FinanceFilters>(initialTableFilters);

    const [getFinanceHistory, { data, isLoading, isFetching }] =
        useLazyGetFinancePaymentHistoryQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };
            getFinanceHistory(payload, true);
        }
    }, [filters]);

    const onFiltersUpdate = (update: Partial<FinanceFilters>) => {
        setTableFilters({ ...tableFilters, ...update });
    };

    return (
        <FinanceTable
            loading={isLoading || isFetching}
            tableFilters={tableFilters}
            onFiltersUpdate={onFiltersUpdate}
            source={data}
        />
    );
};
